import { apiSlice } from '../app/api/apiSlice';

export const CustomFormulaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    customFormula: builder.mutation({
      query: (payload) => ({
        url: 'custom-formula',
        method: 'POST',
        body: { ...payload },
      }),
    }),
    getCustomFormula: builder.query({
      query: ({ formulaId, lang }) => ({
        url: `custom-formula?formula_id=${formulaId}&lang=${lang || 'en'}`,
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    existingFormula: builder.mutation({
      query: (payload) => ({
        url: `existing-formula`,
        method: 'POST',
        body: { ...payload },
      }),
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    createNutritionist: builder.mutation({
      query: (payload) => ({
        url: '/nutritionist',
        method: 'POST',
        body: { ...payload },
      }),
    }),
  }),
});

export const {
  useCustomFormulaMutation,
  useGetCustomFormulaQuery,
  useExistingFormulaMutation,
  useCreateNutritionistMutation,
} = CustomFormulaApiSlice;
